import React from "react";
import { useObserver } from "mobx-react";
import yup from "yup";
import { ClickAwayListener } from "@material-ui/core";
import { useFormStore } from "@modules/formx-react/useFormStore";
import { Form, Text } from "@components/formx";
import { SpinnerOverlay } from "../SpinnerOverlay";

type Props = {
  onSubmit: (values: FormState) => Promise<any>;
  onCancel: () => void;
  initialValue: FormState;
  submitOnCancel?: boolean;
};

type FormState = {
  text: string;
};

export function InlineForm(props: Props) {
  const form = useFormStore<FormState>({
    schema: yup.object({
      text: yup.string().required("Cannot be empty")
    }),
    onSubmit: () => props.onSubmit(form.values),
    initialValues: props.initialValue
  });

  function cancel() {
    if (props.submitOnCancel) {
      return form.submitAsync();
    }
    props.onCancel();
  }

  function onKeyDown(e: React.KeyboardEvent) {
    if (e.key === "Escape") {
      e.stopPropagation();
      cancel();
    }
  }

  function clickAway() {
    if (props.initialValue.text === form.values.text) {
      props.onCancel();
    } else {
      form.submit();
    }
  }

  return useObserver(() => (
    <ClickAwayListener onClickAway={clickAway}>
      <Form store={form} allowUpdates>
        <div style={{ position: "relative" }}>
          <SpinnerOverlay show={form.isSubmitting} size={16} />
          <Text
            name="text"
            TextFieldProps={{
              autoFocus: true,
              fullWidth: true,
              multiline: true,
              onKeyDown
            }}
          />
        </div>
      </Form>
    </ClickAwayListener>
  ));
}
